// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-2MHPE";
var _4 = "header-3A0_F";
var _5 = "header__text-3jcO9";
var _6 = "content__text-1Ni79";
var _7 = "message__text-1PmPa";
var _8 = "content__text_hidden-3YnBf";
var _9 = "footer-3NheD";
var _a = "button__confirm-3sdAg";
var _b = "button__cancel-3UeGB";
var _c = "delete_order-1PKME";
var _d = "header__icon-1t024";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "header", _5 as "header__text", _6 as "content__text", _7 as "message__text", _8 as "content__text_hidden", _9 as "footer", _a as "button__confirm", _b as "button__cancel", _c as "delete_order", _d as "header__icon" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "header": _4, "header__text": _5, "content__text": _6, "message__text": _7, "content__text_hidden": _8, "footer": _9, "button__confirm": _a, "button__cancel": _b, "delete_order": _c, "header__icon": _d }
